import { startClientSentry } from '../sentry.client.config';
import { startIdentityDiagnostics } from './reporting/identityDiagnostics';
import { env } from './utils/env';

startClientSentry();

// TECH-26-151 固定采样 10% 页面会话，命中后才安装身份生命周期诊断。
startIdentityDiagnostics({
  sampleRate: 0.1,
  release: env.NEXT_PUBLIC_IDENTITY_DIAGNOSTICS_RELEASE,
  site: env.NEXT_PUBLIC_SITE_NAME || 'unknown',
});
